import { useEffect, useState } from 'react'
import { LoginPage } from './mods/login-page/LoginPage'
import { ReleasesPage } from './mods/releases-page/ReleasesPage'

export function App () {
	const [screen, setScreen] = useState<'access' | 'releases'>('access')
	useEffect(() => {
		const onBack = (e: PopStateEvent) => {
			e.preventDefault()
			if (screen === 'releases') setScreen('access')
		}
		window.addEventListener('popstate', onBack)
		return () => { window.removeEventListener('popstate', onBack) }
	}, [screen])

	return screen === 'access'
		? <LoginPage onAccessGranted={() => setScreen('releases')} />
		: <ReleasesPage onSignOut={() => setScreen('access')} />
}

export default App